<template>
  <div class="page 404 not-found">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="error mt-5">
            <div class="code">404</div>
          </div>
          <h1 class="text-center">Oops ! La page est introuvable</h1>
          <div class="go-home text-center mt-5">
            <router-link class="btn btn-primary" to="/">Vers la page d'accueil.</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted () {}
}
</script>
<style lang="scss">
.not-found{
  min-height: 90vh;
}
.error{
  text-align: center;
  .code{
    font-size: 10em;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PageNotFound.vue